import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { RestApiEndpoints } from '../enums/rest-api-endpoints';
import { CredentialsService } from './credentials.service';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  private apiURL: string = this.credentialsService.isRunningInElectron ? 'http://192.168.135.10/api/' : 'api/';

  constructor(private httpClient: HttpClient, private credentialsService: CredentialsService) { }

  sendAsyncRequestToEndpoint(endpoint: RestApiEndpoints, payload?: any, completionHandler?: (success: boolean, response?: any) => void) {
    const requestUrl = this.apiURL + endpoint;

    const httpHeaders: any = {};

    const sessionID = localStorage.getItem('sessionID');
    if (sessionID) {
      httpHeaders.sessionID = sessionID;
    }

    const sessionToken = localStorage.getItem('sessionToken');
    if (sessionToken) {
      httpHeaders.sessionToken = sessionToken;
    }

    const requestOptions = {
      headers: new HttpHeaders(httpHeaders)
    };

    if (payload) {
      this.httpClient.post(requestUrl, payload, requestOptions).subscribe({
        next: (response) => { if (completionHandler) { completionHandler!(true, response) } },
        error: (error) => { if (completionHandler) { completionHandler!(false, error) } },
        complete: () => { /* TODO: As soon as I know what this is for, I maybe will start using it. */ }
      });
    } else {
      this.httpClient.get(requestUrl, requestOptions).subscribe({
        next: (response) => { if (completionHandler) { completionHandler!(true, response) } },
        error: (error) => { if (completionHandler) { completionHandler!(false, error) } },
        complete: () => { /* TODO: As soon as I know what this is for, I maybe will start using it. */ }
      });
    }
  }

}
